export const DEFAULT_SIP_TRUNK_NAME = 'Default SIP Trunk'

// set at build time from MIX_SIP_SERVER (CI secrets, .env locally)
// !TODO: the SIP server address should come from the API with the number
export const SIP_SERVER = process.env.MIX_SIP_SERVER

export const ZOIPER_DOWNLOAD_URL = 'https://www.zoiper.com/en/voip-softphone/download/current'

// !TODO: a link to our own Zoiper guide once it is published
export const ZOIPER_GUIDE_URL = '#'

// only a call answered through our SIP server has a talk time and a SIP line;
// a missed one and one answered in the Viber app show a dash there
export const ANSWERED = 'answered'
